module.exports = __webpack_public_path__ + "static/media/logo-alfa.05e97081.svg";